import { PermissionEnum } from '@api/enum';
import useAuthPermission from '@hooks/use-auth-permission';
import { Button, CircularProgress, Sidebar } from '@hyperflake/react-ui-library';
import { BackButton } from '@library/buttons';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

const AnalyticsSidebar = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const { hasPermission } = useAuthPermission();

    const navItems = [
        {
            content: 'Sign In Logs',
            href: '/analytics/sign-in-logs',
            isActive: pathname.startsWith('/analytics/sign-in-logs'),
            permission: hasPermission(PermissionEnum.SIGN_IN_LOGS_READ),
        },
        {
            content: 'Latest Installation Logs',
            href: '/analytics/latest-installations',
            isActive: pathname.startsWith('/analytics/latest-installations'),
            permission: hasPermission(PermissionEnum.CAMERA_INSTALLATION_LOGS_READ),
        },
        {
            content: 'LiveLapse Logs',
            href: '/analytics/live-lapse-logs',
            isActive: pathname.startsWith('/analytics/live-lapse-logs'),
            permission: hasPermission(PermissionEnum.LIVE_LAPSE_LOGS_READ),
        },
        {
            content: 'Multi-Image Logs',
            href: '/analytics/multi-image-logs',
            isActive: pathname.startsWith('/analytics/multi-image-logs'),
            permission: hasPermission(PermissionEnum.MULTI_IMAGE_LOGS_READ),
        },
        {
            content: 'Scheduled Report',
            href: '/analytics/scheduled-report',
            isActive: pathname.startsWith('/analytics/scheduled-report'),
            permission: hasPermission(PermissionEnum.SCHEDULED_REPORTS_READ),
        },
        {
            content: 'Public API Logs',
            href: '/analytics/public-api-logs',
            isActive: pathname.startsWith('/analytics/public-api-logs'),
            permission: hasPermission(PermissionEnum.PUBLIC_API_LOGS_READ),
        },
        {
            content: 'ProgressLine Activity',
            href: '/analytics/progress-line-activity',
            isActive: pathname.startsWith('/analytics/progress-line-activity'),
            permission: hasPermission(PermissionEnum.PROGRESS_LINE_ACTIVITY_READ),
        },
        {
            content: 'Comments Activity',
            href: '/analytics/comments-activity',
            isActive: pathname.startsWith('/analytics/comments-activity'),
            permission: hasPermission(PermissionEnum.COMMENTS_ACTIVITY_READ),
        },
        {
            content: 'Whatsapp Activation',
            href: '/analytics/whatsapp-activity',
            isActive: pathname.startsWith('/analytics/whatsapp-activity'),
            permission: hasPermission(PermissionEnum.WHATSAPP_ACTIVITY_READ),
        },
        {
            content: 'BIM Activation',
            href: '/analytics/bim-servied',
            isActive: pathname.startsWith('/analytics/bim-servied'),
            permission: hasPermission(PermissionEnum.WHATSAPP_ACTIVITY_READ),
        },
        {
            content: 'AI Activation',
            href: '/analytics/ai-serviced',
            isActive: pathname.startsWith('/analytics/ai-serviced'),
            permission: hasPermission(PermissionEnum.WHATSAPP_ACTIVITY_READ),
        },
        {
            content: 'Inactivity Triggers',
            href: '/analytics/inactivity-triggers',
            isActive: pathname.startsWith('/analytics/inactivity-triggers'),
            permission: hasPermission(PermissionEnum.INACTIVE_USER_EMAIL_LOGS_READ),
        },
        {
            content: 'AI Wrong Information',
            href: '/analytics/ai-wrong-information/ai-people-flow',
            isActive: pathname.startsWith('/analytics/ai-wrong-information'),
            permission: hasPermission(PermissionEnum.AI_WRONG_INFORMATION_READ),
        },
        {
            content: 'Daily Activity',
            href: '/analytics/daily-activity',
            isActive: pathname.startsWith('/analytics/daily-activity'),
            permission: hasPermission(PermissionEnum.DAILY_ACTIVITY_READ),
        },
        // {
        //     content: `${clientInstallation?.name}`,
        //     href: `/client-installations/${clientInstallationId}/details`,
        //     isActive: pathname.startsWith(`/client-installations/${clientInstallationId}/details`),
        //     permission: hasPermission(PermissionEnum.CLIENT_INSTALLATION_READ),
        // },
        // {
        //     content: 'Projects',
        //     href: `/client-installations/${clientInstallationId}/project-installations`,
        //     isActive: pathname.startsWith(`/client-installations/${clientInstallationId}/project-installations`),
        //     permission: hasPermission(PermissionEnum.PROJECT_INSTALLATION_READ),
        // },
    ];
    return (
        <Sidebar className="border-r-0 md:border-r ">
            <Sidebar.Nav>
                <>
                    {/* <Link
                        to={`/`}
                        // to=""
                        // /clients/10212/projects/21091/cctv-cameras/98673426/edit-cctv
                    >
                        <div className="p-4">{`<-  Back`}</div>
                    </Link> */}
                    <BackButton className="ml-2 text-xs" to="/clients" />
                    <div className=" border-b-2 font-semibold p-2 ml-2 mt-4">Analytics</div>

                    <div className="mt-2">
                        {navItems.map(
                            (row, i) =>
                                row.permission && (
                                    <Sidebar.NavItem key={i} isActive={row.isActive} onClick={() => navigate(row.href)}>
                                        <Link to={row.href}>{row.content}</Link>
                                    </Sidebar.NavItem>
                                )
                        )}
                    </div>
                </>
            </Sidebar.Nav>
        </Sidebar>
    );
};

export default AnalyticsSidebar;
